import { Lock, Compass, Globe } from "lucide-react";
import { Reveal } from "./Reveal";
import { useLang } from "../config/i18n";

const ICONS = [Lock, Compass, Globe];

export const Highlights = () => {
  const { t } = useLang();

  return (
    <section data-testid="hero-highlight-cards" className="relative py-20 sm:py-28 border-t border-[#22222B]">
      <div className="max-w-6xl mx-auto px-6 grid gap-6 sm:grid-cols-3">
        {t.highlights.map(({ title, text }, i) => {
          const Icon = ICONS[i];
          return (
            <Reveal key={title} delay={i * 0.12}>
              <div
                data-testid={`highlight-card-${i + 1}`}
                className="h-full p-8 rounded-2xl bg-[#121216] border border-[#22222B] hover:border-[#C5A059]/40 transition-colors duration-500 group"
              >
                <Icon size={26} className="text-[#C5A059] mb-6 transition-transform duration-500 group-hover:scale-110" strokeWidth={1.4} />
                <h3 className="font-heading text-base tracking-[0.15em] text-[#F7F7F8] uppercase mb-3">{title}</h3>
                <p className="text-sm text-[#A3A3AF] leading-relaxed font-light">{text}</p>
              </div>
            </Reveal>
          );
        })}
      </div>
    </section>
  );
};
